import React, { useContext, useState, useEffect } from 'react';
import LogCard from './../components/LogCard';
import { WebSocketContext } from "../WebSocketContext";
import './../Trades.css'; // Assuming you have a CSS file for styles
import { Refresh } from '@mui/icons-material';
import config from '../config'; // Assuming you have a config file with API_BASE_URL

const RejectionLogs = () => {

    const [rejectionLogs, setRejectionLogs] = useState([]);
    const user_id = Number(localStorage.getItem('userId'));

    const getRejectionLogs = async () => {
        try 
        {  
          const response = await fetch(`${config.API_BASE_URL}getTodayRejectionLog`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer 7c85cfc0ad2328331d4784ffedb97565154cd2016ed0b2b6843a53e7f2a2343d` // Ensure this is stored securely
            },
            body: JSON.stringify({ user_id, user_type:'client' }),
          });
          
          const data = await response.json();
          
          setRejectionLogs(data); 

        } catch (error) {
          console.error('Error fetching rejection logs:', error);
        }
    };

    useEffect(() => {
        getRejectionLogs();
      }, []);

    const handleRefresh = () => {
        getRejectionLogs();
    };

  return (
    <div className="trades-page">
      
      <button className="refresh-button" onClick={handleRefresh}><Refresh /></button>
      
      {rejectionLogs.length > 0 ? (
        rejectionLogs.map(log => (
          <LogCard 
            key={log.id} 
            log={log} 
          />
        ))
      ) : (
        <div className="rejection-logs-empty-state">
          <div className="rejection-logs-empty-state-icon">
            <div className="rejection-logs-icon-container">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <div className="rejection-logs-empty-state-content">
            <h3 className="rejection-logs-empty-state-title">No Rejection Logs</h3>
            <p className="rejection-logs-empty-state-description">
              Great news! You don't have any rejection logs today.
              All your orders have been processed successfully.
            </p>
            <div className="rejection-logs-empty-state-actions">
              <button className="rejection-logs-primary-action-btn" onClick={handleRefresh}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 12A9 9 0 0 1 12 3A9 9 0 0 1 21 12A9 9 0 0 1 12 21A9 9 0 0 1 3 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 3V12L16.5 16.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Refresh
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RejectionLogs;

